import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Pagination from '../pagination/Pagination'
import { Link } from 'react-router-dom'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

const DgDiary = () => {

  const [DgDiary,setDgDiary]=useState([])
  const[showPerPage,setShowPerPage]=useState(20)
  const [pagination,setPagination]=useState(
    {
      start:0,
      end:showPerPage
    }
  )
 
  const onChangePagination=(start,end)=>{
    setPagination({start:start,end:end})
  }

const DgDiarysData = async () => {
  const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session
  const res = await axios.get(`https://lionsdirectoryapi.emedha.in/DGDiary/api/diary/get?dist=${dist}`);
  setDgDiary(res.data);
};


  useEffect(() => {
    DgDiarysData()
  }, []);

  
const deleteData = (id) => {
  const dist = sessionStorage.getItem("dist");
  if (window.confirm('Are you sure to delete this data...')) {
    axios.post(`https://lionsdirectoryapi.emedha.in/DGDiary/api/diary/delete`, {
      id,
      dist
    });
    alert('Data deleted successfully!...');
    setTimeout(() => DgDiarysData(), 100);
  }
};


  return (
   <div>
    <Link to='/add-DG-dairy'> <button  className='btn btn-warning'>
          Add<PersonAddAltIcon></PersonAddAltIcon>
       </button></Link>
    <div style={{marginTop:'1rem'}} className='table-container'>
        
        <table className="styled-table table table-bordered">
         <thead>
           <tr>
             <th>S.No</th>
             <th>Start Date</th>
             <th>End Date</th>
             <th>Program</th>
             <th>Description</th>
             <th>Update</th>
             <th>Delete</th>
           </tr>
           
         </thead>
         <tbody className='table-bordered'>
           {
             DgDiary.slice(pagination.start,pagination.end).map((data,index)=>{
               return(
                 <tr>
                    <td>{pagination.start + index + 1}</td>
                   <td>{data.startDate}</td>
                   <td>{data.endDate}</td>
                   <td>{data.program}</td>
                   <td>{data.description}</td>
                   <td className=''>
                     <Link  className='btn btn-info' to={`/Dg-Diary-update/${data.id}`}>update</Link>
                   </td>
                   <td className=''>
                     <Link to='#' className='btn btn-danger' onClick={()=>deleteData(data.id)}>delete</Link>
                   </td>
                 </tr>
               )
             })
           }
         </tbody>
        </table>
       <Pagination page={showPerPage} onChangePagination={onChangePagination} total={DgDiary.length}/>      
   </div>
   </div>
  )
}

export default DgDiary